/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

/*       */

import dayjs from 'dayjs';

export default (startTime, endTime) =>
  dayjs.unix(endTime).diff(dayjs.unix(startTime), 'minutes', true);
